<div class="container-fluid">
  <p> {{"Delete-application.please-contact" | translate}} </p>
  <button id="ok-button" (click)="onOkClick()" >OK</button>
</div>
